import React from 'react';

import './NearTerm.css';
import {Detail} from '../../api/api';
import moment from 'moment'
import {FormattedMessage} from 'react-intl';
import {connect} from "react-redux"
import actions from "../../store/actions"
let img1 = require("../../static/images/QRCode.jpg");

 class NearTerm extends React.Component {
    // constructor(props, context) {
    //     super(props, context);
    // }

    state = {
        Detail1: {}
    };
    componentWillMount() {
        let id = this.props.location.state.ID;
        Detail(id).then((response) => {
            let data = response.DataResult;
            this.setState({
                Detail1: JSON.parse(JSON.stringify(data))
            })
        }).catch((error) => {
            console.log(error);
        })
    }


    render() {
        let Detail1 = this.state.Detail1;
        if (JSON.stringify(Detail1) === "{}") {
            return ""
        }
        return (<div className="nearTerm">
                {/*标题*/}
                <div className="nearTermLogo">
                    <div className="nearTermTitle">
                        <h4 className="nearTermTitleH4">
                            {this.props.local === "en" ?
                                <div dangerouslySetInnerHTML={{__html: Detail1.titleEn}}></div> :
                                <div dangerouslySetInnerHTML={{__html: Detail1.titleCn}}></div>
                            }</h4>
                        <p className="timeLineP">
                            <span> <FormattedMessage
                                id="intl-Publish-Date"
                            />：{Detail1.PublishTime ? moment(Detail1.PublishTime).format('YYYY-MM-DD') : moment(Detail1.CreationTime).format('YYYY-MM-DD')}</span>
                        </p>
                    </div>
                    <div className="line1"></div>
                    <ul className="newList1-ul">
                        <li className="newList1-li">
                            {this.props.local === "en" ?
                                <div dangerouslySetInnerHTML={{__html: Detail1.contentEn}}></div> :
                                <div dangerouslySetInnerHTML={{__html: Detail1.contentCn}}></div>}
                        </li>
                    </ul>
                </div>

            </div>
        )
    }
}
export default connect(state => ({ ...state.Language}), { ...actions.Language})(NearTerm)


// WEBPACK FOOTER //
// ./src/containers/News/NearTerm.js